import React from 'react';
import { SvgIconWarning } from '@modules/ui/icons/EngineReferenceIcons';
import EngineMarkdown from '@modules/ui/markdown/components/EngineMarkdown';
import useReferenceDeprecationWarningStyles from './ReferenceDeprecationWarning.styles';

interface ReferenceDeprecationWarningProps {
  deprecationMessage: string;
}

function ReferenceDeprecationWarning({ deprecationMessage }: ReferenceDeprecationWarningProps) {
  const { classes } = useReferenceDeprecationWarningStyles();

  return (
    <div className={classes.container}>
      <div className={classes.iconWrapper}>
        <SvgIconWarning />
      </div>
      <div>
        <EngineMarkdown overrideParagraphStyle={{ marginBottom: 0 }}>
          {deprecationMessage}
        </EngineMarkdown>
      </div>
    </div>
  );
}

export default ReferenceDeprecationWarning;
